export const siteConfig = {
  appUrl: import.meta.env.VITE_APP_URL || "https://app.fc-teugn-talents.de",
  androidDownloadUrl: import.meta.env.VITE_ANDROID_DOWNLOAD_URL || "https://magentacloud.de/s/xkgHEESdKbQ6XMP",
  siteUrl: import.meta.env.VITE_SITE_URL || "https://fc-teugn-talents.de",
  legal: {
    organization: "FC Teugn e.V.",
    representedBy: "Florian Christl (1. Vorstand)",
    street: "Kreutweg 13",
    city: "93356 Teugn",
    email: "info@fc-teugn.de",
    registerCourt: "Vereinsregister des Amtsgerichts Regensburg",
    registerNumber: "VR 70102",
    // Nur befüllen, wenn die Website journalistisch-redaktionelle Inhalte anbietet.
    // Diese statische App-Landingpage enthält derzeit keine solchen Inhalte.
    contentResponsible: "",
    contentResponsibleAddress: "",
  },
} as const;
